<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <!-- <Toast style="margin-top: 35px" /> -->
        <form>

          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="fromDate">From Date</label>
              <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="fromDate"
                         v-model="fromDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">To Date</label>
              <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
              <InputMask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="toDate"
                         v-model="toDate"/>
            </div>

            <div class="p-field p-col-12 p-md-2">
            <label for="warehouse">Transfer From</label>
            <Dropdown
              v-model="warehouseIdFrom"
              :options="warehouseLists"
              optionLabel="name"
              id="warehouse"
              :filter="true"
              placeholder="Select from warehouse"
              :showClear="true"
            />
            </div>
            <div class="p-field p-col-12 p-md-2">
            <label for="warehouse">Transfer To</label>
            <Dropdown
              v-model="warehouseIdTo"
              :options="warehouseLists"
              optionLabel="name"
              id="warehouse"
              :filter="true"
              placeholder="Select to warehouse"
            />
          </div>
            <!-- <label for="voucher" class="col-sm-1 control-label">Voucher</label> -->
            <div class="p-field p-col-12 p-md-1 p-mt-5">
              <Button @click.prevent="searchOrder"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
            </div>

            <div class="p-field p-col-12">
              <a href="#" @click.prevent="exportCSV()" v-if="this.stockTransforList.length > 0">
                <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
              </a>
            </div>
          </div>

           <label style="color:red" for="name">Note: Please click search after update!<span
          style="color:red"></span></label>


          <Dialogs header="Reason" :visible.sync="ecommerceStatusDialog"
                   :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
            <div class="col-md-12">
              <label for="reason" class="col-md-4 control-label">Reason</label>
              <div class="form-group col-md-8">
                <textarea class="form-control" rows="5" v-model="reason"></textarea>
              </div>
            </div>
            <template #footer>
              <Button class="btn btn-danger" type="submit" @click.prevent="updateOrderStatus">Send</Button>
              <Button class="btn btn-success" type="submit" @click.prevent="cancel">Cancel</Button>
            </template>
          </Dialogs>
        </form>

        <DataTable :value="stockTransforLists" dataKey="id" ref="dt"
                   :paginator="true" editMode="cell"
                   :rows="10" :filters="filters"
                   class="editable-cells-table p-datatable-gridlines">
          <!-- <Column selectionMode="multiple" headerStyle="width: 3rem"></Column> -->
          <Column header="S.N">
            <template #body="sl">
              {{ sl.index + 1 }}
            </template>
          </Column>
          <Column header="Miti" headerStyle="width:8em;" :sortable="true" field="transforDateNepali"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['transforDateNepali']"/>
            </template>
          </Column>
          <Column header="Date" headerStyle="width:8em;" :sortable="true" field="transforDate"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['transforDate']"/>
            </template>
          </Column>
          <Column header="Transfer No" :sortable="true" field="transforNo" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['transforNo']"/>
            </template>
          </Column>
          <Column header="Store From" :sortable="true" field="warehouseFromDTO.name" filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['warehouseFromDTO.name']"/>
            </template>
          </Column>
          <Column header="Store To" bodyStyle="text-align: right" :sortable="true" field="warehouseToDTO.name"
                  filterMatchMode="contains">
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['warehouseToDTO.name']"/>
            </template>
          </Column>

          <Column header="Action">
            <template #body="slotProps">
              <!-- <Button v-if="enableEdit" class="p-button-raised p-button-success"
                      @click="editStockTransfor(slotProps.data)" icon="pi pi-pencil"/>
              <Button v-else disabled class="p-button-raised p-button-success"
                      @click="editStockTransfor(slotProps.data)" icon="pi pi-pencil"/>
              <Button v-if="enableDelete" class="p-button-raised p-button-danger"
                      @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
              <Button v-else disabled class="p-button-raised p-button-danger"
                      @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/> -->
              <Button icon="pi pi-eye" class="p-button-raised p-button-warning"
                      @click="viewPIVDetail(slotProps.data)"/>
              <!-- <Button icon="pi pi-print" class="p-button-raised"
                      @click="exportToPdf(slotProps.data.id)"/> -->
            </template>


          </Column>
        </DataTable>
      </div>
    </div>

    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputText from 'primevue/inputtext'
import InputMask from 'primevue/inputmask'
import Dropdown from 'primevue/dropdown'
import Dialogs from 'primevue/dialog'
import Checkbox from 'primevue/checkbox'
import Button from 'primevue/button'

export default {
  name: 'salesOrderReport',
  data() {
    return {
      fromDate: null,
      toDate: null,
      warehouseIdFrom: '',
      warehouseIdTo: '',
      stockTransforList: [],
      loading: false,
      dialogShow: false,
      columnList: '',
      filters: {},
      englishDateEnabled: true,
      idsForOrderPrint: [],
      selectedSalesOrderId: null,
      ecommerceStatusDialog: false,
      reason: '',
      ecommerceStatusData: '',
      inventoryHeaderId: null,
      enableEdit: false,
      enableDelete: false,
      // [{label: 'In Stock', value: 'INSTOCK'},{label: 'Low Stock', value: 'LOWSTOCK'},{label: 'Out of Stock', value: 'OUTOFSTOCK'}]
      statuses: [{label: 'Processing', value: 'Processing'}, {label: 'Hold', value: 'Hold'}, {
        label: 'Completed',
        value: 'Completed'
      }, {label: 'Cancel', value: 'Cancelled'}]
    }
  },
  mounted() {
    this.warehouseList()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
    this.checkEnableEdit()
    this.checkEnableDelete()
  },
  computed: {
    stockTransforLists() {
      return this.$store.state.sales.stockTransforLists
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  methods: {
    async searchOrder() {
      let dat = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        warehouseFromId: this.warehouseIdFrom.id,
        warehouseToId: this.warehouseIdTo.id
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadStockTransforInternalStoreWiseLists', dat)
      this.loading = false
      if (resp.data.data.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
        this.stockTransforList = []
      } else {
        this.stockTransforList = resp.data.data
      }
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async viewPIVDetail(data) {
      let PIHdata = {
        id: data.id,
        transforNo: data.transforNo,
        reportType: data.reportType,
        transforDate: data.transforDateNepali,
        warehouseFromName: data.warehouseFromName,
        warehouseToName: data.warehouseToName
      }
      this.$router.push({name: 'stock Transfor Details Store Wise', params: {salesHeaderObj: PIHdata}})
    },
    checkEnableEdit() {
      if (this.$store.getters.modules.includes(',5.08')) {
        this.enableEdit = true
      }
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.13')) {
        this.enableDelete = true
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList,
        warehouseFromId: this.warehouseIdFrom.id,
        warehouseToId: this.warehouseIdTo.id
      }
      axios({
        url: globalKey + '/fileDownload/excelReportStockTransforStoreWise/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/stockTransfor' + '/' + this.$store.getters.fyId + '/' + data.columnList + '/' + data.warehouseFromId + '/' + data.warehouseToId,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel'},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'stockTransfor.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    exportToPdf(SOHeaderId) {
      axios({
        url: globalKey + '/fileDownload/printSalesBill/' + SOHeaderId + '/salesOrder' + '/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId,
        method: 'get',
        headers: {'Accept': 'application/pdf'},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'salesOrder.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    expexportToPdfOrderortToPdf() {
      if (this.selectedSalesOrderId !== null) {
        this.selectedSalesOrderId.forEach(salesOrderId => this.idsForOrderPrint.push(salesOrderId.id))
      }
      if (this.idsForOrderPrint.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select atleast one order!', life: 10000})
        return
      }
      if (this.idsForOrderPrint.length > 5) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Sorry Cannot more then 5 order!', life: 10000})
        return
      }
      axios({
        url: globalKey + '/fileDownload/printOrderForKritiCraft/' + this.$store.getters.organisationId + '/' +
          this.$store.getters.userId + '/' + this.idsForOrderPrint,
        method: 'get',
        headers: {'Accept': 'application/pdf'},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'Order No' + this.idsForOrderPrint + '.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
      this.idsForOrderPrint = []
      this.selectedSalesOrderId = null
    },
    columnNames() {
      for (let i = 0; i < this.$refs.dt.columns.length; i++) {
        this.columnList += this.$refs.dt.columns[i].header + ','
      }
    },
    editStockTransfor(data) {
      this.$router.push({name: 'Stock Transfer (Internal)', params: {stockTransferInternal: data}})
    },
    selectedSalesOrder(data) {
      // this.selectedSalesOrderId.push(data.id)
      if (!this.idsForOrderPrint.includes(data)) {
        this.idsForOrderPrint.push(data)
      }
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        inventoryOutHeaderId: this.accountId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deleteStockTransfor', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
      this.dialogShow = false
    },
    cancel(data) {
      this.dialogShow = false
      this.ecommerceStatusDialog = false
      this.reason = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountId = id
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    reset() {
      this.stockTransforLists = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dialog,
    InputText,
    // Toast,
    InputMask,
    Dropdown,
    Dialogs,
    Checkbox,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// stockTransforReportWarehouseWise.vue?6df010de